module.exports = __webpack_public_path__ + "assets/img/intro-vip-a3.43cac4aa.jpg";